module.exports = __webpack_public_path__ + "img/Vector.ca1ab809.svg";